import { render, staticRenderFns } from "./CommonActionComponent.vue?vue&type=template&id=6a20ebd2&"
import script from "./CommonActionComponent.vue?vue&type=script&lang=ts&"
export * from "./CommonActionComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CommonActionComponent.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports